<template xmlns="http://www.w3.org/1999/html">
  <div class="login-box">
    <header class="login-logo spaceBetween">
      <img src="@/assets/images/nylogo.png" alt="" srcset="" height="40">
    </header>
    <section class="spaceCenter login-main">
        <div class="login-text">
        </div>
        <div class="login-form spaceCenter">
          <transition name="fade2" mode="out-in">
            <router-view/>
          </transition>
        </div>
    </section>
    <footer>
        <div class="footer-text">
            <span><a href="https://beian.miit.gov.cn" target="_blank" style="color:#666;">Copyright@2023 南阳商祺数贸科技有限公司 电话:400-0377-900
</br>版权所有豫ICP备2023000680号-2 豫ICP证B2-20231049号</a></span>
            <a class="app-a" @click="showModal">《告知书》</a>
        </div>
    </footer>
     <!-- 弹窗 -->
        <a-modal
        :bodyStyle="{height:'500px',overflow:'auto'}"
        width="600px"
        title="告知书"
        :visible="modalShow"
        @cancel="modalCancel"
        >
        <template slot="footer">
            <div class="spaceCenter">
            <a-button type="primary" @click.stop="()=>{modalShow=false}">关闭</a-button>
            </div>
        </template>
        <notification></notification>
        </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { loginApi } from "@/api/login";
import { JSEncrypt } from "jsencrypt";
import { systemDate } from "@/api/communal";
import notification from "@/components/login/notification"

export default {
  name: "login",
  components: {notification},
  data() {
    return {
      tenantName: "",
      username: "",
      password: "",
      captcha: "",
      pubKey:
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlkiJ5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWelXoiDILtf78vFLvnOQIDAQAB",
      encrypt: new JSEncrypt(),
      sequence:"",
      usernameErr:false,
      passwordErr:false,
      captchaErr:false,
      loadLogin:false,
      modalShow:false
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapMutations({
      setUserObj: "home/setUserObj",
    }),
    toRegister(){
      this.$router.push("/login/register")
    },
    toCodeLogin(){
      window.open(process.env.VUE_APP_BASE_LOGIN_URL);
    },
    toCodeAdd(){
      window.open(process.env.VUE_APP_BASE_REGISTER_URL);
    },
    showModal(text, record) {
        this.modalShow = true;
    },
    modalCancel(e) {
        this.modalShow = false;
    },
    toHelp(){
      window.open(process.env.VUE_APP_WIKI_URL)
    }
  },
  beforeDestroy(){
    this.loadLogin = false;
  }
};
</script>
<style scoped lang="less">
.login-box {
  padding-top:4%;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 1160px;
}
.login-logo {
  width: 80%;
  margin:0 auto;
  margin-bottom:10px;
  .logo-text{
    height: 55px;
    display: inline-block;
    margin-left:12%;

  }
  .logo-right{
    border-left:1px solid #d1dff0;
    margin-left:12px;
    padding-left:12px;
    color:#065abc;
    font-size: 16px;
    font-weight: bold;
    .logo-right-sm{
      font-size: 12px;
      font-weight: lighter;
    }
  }
}

section{
    width: 100%;
    margin:0 auto;
    background: url("../assets/images/login/scx_bg.png") no-repeat;
    background-size: 100% 100%;
}
.login-form{
    width: 450px;
    background: #fff;
    padding: 24px 30px;
    border-radius: 4px;
    position: absolute;
    right:10%;
    top:50%;
    margin-top:-235px;
}

.footer-text{
  text-align: center;
  margin:0 auto;
  margin-top:24px;
  color: #333333;
}

.fade2-enter {
  opacity:0;
}
.fade2-leave{
  opacity:1;
}
.fade2-enter-active{
  transition:all ease 1s;
}
.login-main{
  height: 70vh;
  max-height:610px;
}
.login-center{
  display: inline-block;
}

.login-scx{
  text-align: center;
  .h1{
    font-size: 26px;
    color: #EF2524;
  }
  .h2{
    margin:24px 0;
  }
  button{
    width: 100%;
    margin-bottom:13px;
  }
  .desc{
    text-align: left;
    font-size:12px;
    color:#666;
    margin-top:20px;
  }
}
@media only screen and (max-width: 786px){
    .login-text{
      transform: scale(0.7);
      transform-origin: center;
    }
}

@media only screen and (max-width: 1366px) and (min-width:787px) {
  .login-text{
    transform: scale(0.8);
    transform-origin: center;
  }
}

@media only screen and (max-width: 1400px) and (min-width:1367px) {
  .login-text{
    transform: scale(0.9);
    transform-origin: center;
  }
}

@media only screen and (max-width: 1600px) and (min-width:1401px) {
  .login-text{
    transform: scale(0.9);
    transform-origin: center;
  }
}

@media only screen and (max-width: 1920px) and (min-width:1601px)  {
  .login-text{
    transform: scale(1);
    transform-origin: center;
  }
}
a{
  color: #1990FF;
}
.login-help{
	color:#333333;
	font-size: 18px;
	position: absolute;
	top: -120px;
	right: 3px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components-frame/login.vue